"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const TyreFilter_vue_1 = __importDefault(require("../../components/ProductSearch/TyreFilter.vue"));
const tyre_search_1 = require("../../components/ProductSearch/tyre-search");
const Form_1 = require("../../components/Form");
const vue_router_1 = require("vue-router");
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const i18n_1 = require("../../common/i18n");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductTruckTyres',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const tyreFilterRef = (0, vue_3.ref)(null);
        const tyreTypeSelect = (0, vue_3.ref)("122");
        const getTyreTypeItems = () => {
            let tyreTypeItems = [
                new DropdownInputItem_1.default("122", `<i class="marso-icon-tomlo_nelkul"></i> ${(0, i18n_1.trans)("tubeless_tyre", "Tubeless tyre", "truck_tyres")}`),
                new DropdownInputItem_1.default("120", `<i class="marso-icon-coll"></i> ${(0, i18n_1.trans)("20_inches_tyre", "20 inches tyre", "truck_tyres")}`),
            ];
            if ('SRB' != ShopConfig_1.ShopConfig.getShopLocation()) {
                tyreTypeItems.push(new DropdownInputItem_1.default("123|127", `<i class="marso-icon-retread"></i> ${(0, i18n_1.trans)("retreaded_tyre", "Retreaded tyre", "truck_tyres")}`));
            }
            return tyreTypeItems;
        };
        const busSelect = (0, vue_3.ref)(undefined);
        const tractionSelect = (0, vue_3.ref)(undefined);
        const steeredSelect = (0, vue_3.ref)(undefined);
        const trailerSelect = (0, vue_3.ref)(undefined);
        const universalSelect = (0, vue_3.ref)(undefined);
        const form = (0, vue_3.ref)(Object.assign({}, tyre_search_1.truckTyreSearchForm));
        const initQueryParams = (0, tyre_search_1.getQueryParams)(form.value, route);
        for (const key in initQueryParams) {
            if (initQueryParams.hasOwnProperty(key)) {
                if (key === "axCategories") {
                    if (typeof initQueryParams[key] === "object") {
                        tyreTypeSelect.value = `${initQueryParams[key][0]}`;
                    }
                    else {
                        tyreTypeSelect.value = `${initQueryParams[key]}`;
                    }
                    form.value['axCategory'] = initQueryParams[key];
                }
                if (key === "applicationNotation") {
                    for (const notation of initQueryParams[key]) {
                        if (notation === "BUSZ") {
                            busSelect.value = true;
                        }
                        if (notation === "HÚZÓ") {
                            tractionSelect.value = true;
                        }
                        if (notation === "KORM") {
                            steeredSelect.value = true;
                        }
                        if (notation === "PÓTK") {
                            trailerSelect.value = true;
                        }
                        if (notation === "UNIV") {
                            universalSelect.value = true;
                        }
                    }
                }
                form.value[key] = initQueryParams[key];
            }
        }
        (0, vue_3.watch)(() => tyreTypeSelect.value, (selectedValue) => {
            for (const key in form.value) {
                if (!form.value.hasOwnProperty(key)) {
                    continue;
                }
                if (key === "axCategory") {
                    if (selectedValue.includes('|')) {
                        const tyreCategories = selectedValue.split('|');
                        form.value[key] = tyreCategories;
                    }
                    else {
                        form.value[key] = [selectedValue];
                    }
                    busSelect.value = false;
                    tractionSelect.value = false;
                    steeredSelect.value = false;
                    trailerSelect.value = false;
                    universalSelect.value = false;
                    continue;
                }
                if (key === "type") {
                    continue;
                }
                form.value[key] = null;
            }
        });
        const applicationNotationValues = (0, vue_3.computed)(() => {
            const ret = [];
            if (busSelect.value) {
                ret.push("BUSZ");
            }
            if (tractionSelect.value) {
                ret.push("HÚZÓ");
            }
            if (steeredSelect.value) {
                ret.push("KORM");
            }
            if (trailerSelect.value) {
                ret.push("PÓTK");
            }
            if (universalSelect.value) {
                ret.push("UNIV");
            }
            return ret;
        });
        (0, vue_3.watch)(() => applicationNotationValues.value, (applicationNotation) => (form.value.applicationNotation = applicationNotation), { deep: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreFilter_vue_1.default, {
                searchLabel: (0, vue_2.unref)(i18n_1.trans)('truck_tyre_search', 'Truck tyre search', 'truck_tyres'),
                form: form.value,
                placeholder: (0, vue_2.unref)(i18n_1.trans)('tag_search_input_placeholder', 'eg. 29580225 continental', 'truck_tyres'),
                category: "truckTyre",
                ref_key: "tyreFilterRef",
                ref: tyreFilterRef,
                hasAdditionalFilters: "",
                listFields: (0, vue_2.unref)(tyre_search_1.truckTyreProductListFields)
            }, {
                filtersPrepend: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('tyre_type', 'Tyre type', 'truck_tyres'),
                        items: getTyreTypeItems(),
                        modelValue: tyreTypeSelect.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tyreTypeSelect).value = $event)),
                        disableDeselect: ""
                    }, null, 8, ["placeholder", "items", "modelValue"])
                ]),
                additionalFilters: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                        class: "p-2 bg-gray justify-between",
                        label: (0, vue_2.unref)(i18n_1.trans)('bus', 'Bus', 'truck_tyres'),
                        modelValue: busSelect.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((busSelect).value = $event))
                    }, null, 8, ["label", "modelValue"]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                        class: "p-2 bg-gray justify-between",
                        label: (0, vue_2.unref)(i18n_1.trans)('steered', 'Steered', 'truck_tyres'),
                        modelValue: steeredSelect.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((steeredSelect).value = $event))
                    }, null, 8, ["label", "modelValue"]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                        class: "p-2 bg-gray justify-between",
                        label: (0, vue_2.unref)(i18n_1.trans)('traction', 'Traction', 'truck_tyres'),
                        modelValue: tractionSelect.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((tractionSelect).value = $event))
                    }, null, 8, ["label", "modelValue"]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                        class: "p-2 bg-gray justify-between",
                        label: (0, vue_2.unref)(i18n_1.trans)('trailer', 'Trailer', 'truck_tyres'),
                        modelValue: trailerSelect.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((trailerSelect).value = $event))
                    }, null, 8, ["label", "modelValue"]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                        class: "p-2 bg-gray justify-between",
                        label: (0, vue_2.unref)(i18n_1.trans)('universal', 'Universal', 'truck_tyres'),
                        modelValue: universalSelect.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((universalSelect).value = $event))
                    }, null, 8, ["label", "modelValue"])
                ]),
                _: 1
            }, 8, ["searchLabel", "form", "placeholder", "listFields"]));
        };
    }
});
